import React, { useState } from 'react';
import { MessageCircle, Mail } from 'lucide-react';
import { ConfiguracaoWhatsAppSection } from './ConfiguracaoWhatsAppSection';
import { ConfiguracaoEmailSection } from './ConfiguracaoEmailSection';

/**
 * Agrupa os dois canais de notificação automática do sistema (WhatsApp e
 * E-mail), que compartilham os mesmos eventos (OS confirmada, em rota,
 * aguardando assinatura, finalizada, cancelada, fatura disponível) e o mesmo
 * princípio de opt-in do cliente, mas têm configuração e templates próprios.
 */
export function NotificacoesSection() {
  const [canal, setCanal] = useState<'whatsapp' | 'email'>('whatsapp');

  return (
    <div className="space-y-5">
      <div className="inline-flex items-center bg-slate-100 p-1 rounded-xl">
        <button
          type="button"
          onClick={() => setCanal('whatsapp')}
          className={`px-4 py-2 text-xs font-bold rounded-lg transition-all flex items-center gap-1.5 cursor-pointer ${
            canal === 'whatsapp' ? 'bg-white text-slate-900 shadow-xs' : 'text-slate-500 hover:text-slate-800'
          }`}
        >
          <MessageCircle className="w-3.5 h-3.5" />
          WhatsApp
        </button>
        <button
          type="button"
          onClick={() => setCanal('email')}
          className={`px-4 py-2 text-xs font-bold rounded-lg transition-all flex items-center gap-1.5 cursor-pointer ${
            canal === 'email' ? 'bg-white text-slate-900 shadow-xs' : 'text-slate-500 hover:text-slate-800'
          }`}
        >
          <Mail className="w-3.5 h-3.5" />
          E-mail
        </button>
      </div>

      {canal === 'whatsapp' ? <ConfiguracaoWhatsAppSection /> : <ConfiguracaoEmailSection />}
    </div>
  );
}
